export default "assets/images/carbon_phone-voice-121100e7.png";